import { Framework } from '@/framework/instance';
import { IBaseCustomData, IBaseOperateFlag, IMarkupLayerProps, LayerType, MarkupType } from '@/version-types';
import { IEditMessage } from '../../types';
import { OperateType } from '../../types/operate';
import { Collaborators } from '../collaborators';
import { Room } from '../room';

/**
 * 自定义图层操作
 */
export class CustomOperate extends Framework {
    constructor(
        identity: string,
        private room: Room,
        private collaborators: Collaborators,
    ) {
        super(identity);
        this.room.onMessage(OperateType.Custom, this.onReceive.bind(this));
    }

    /** 发送选中图层事件 */
    send(args: IBaseOperateFlag, data: IBaseCustomData) {
        const newLayer = data.data.newLayer;

        // 设置箭头标注笔基础操作后，需要定时同步的数据
        if (newLayer && newLayer.layerType === LayerType.MARKUP_LAYER) {
            const data = newLayer.data as IMarkupLayerProps;
            if (data.markupType === MarkupType.Arrow) {
                this.room.throttleSendToAll(OperateType.Custom, [{ [newLayer.id]: 1 }, args.isEnd ? 1 : 0], args.isEnd);
                if (args.isEnd) {
                    this.room.syncBaseOperateAdapter.set(this.room.collaborators.getWsKey(), newLayer.id, [
                        'data.anchor',
                    ]);
                }
            }
        }
    }

    private onReceive({ fromWsMemberKey, data }: IEditMessage<[Record<string, any>, number]>) {
        const [diffInfo, isEnd] = data;
        Object.keys(diffInfo).forEach((layerId) => {
            if (isEnd) {
                const layer = this.framework.getLayer(layerId);
                if (layer.layerType === LayerType.MARKUP_LAYER) {
                    this.room.syncBaseOperateAdapter.set(fromWsMemberKey, layerId, ['data.anchor']);
                }
            }
        });
    }
}
